import { render, staticRenderFns } from "./TendersActionsManager.vue?vue&type=template&id=2e63604e"
import script from "./TendersActionsManager.vue?vue&type=script&lang=js"
export * from "./TendersActionsManager.vue?vue&type=script&lang=js"
import style0 from "./TendersActionsManager.vue?vue&type=style&index=0&id=2e63604e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports